import { React, useContext, useState } from "react";

import "react-toastify/dist/ReactToastify.css";
import Context from "context/context";
import reportAPI from "apis/panel/reports/reports";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
// import { useScroll } from "../../../../../node_modules/framer-motion/dist/index";
import { Box, FormControl, MenuItem, Select } from "../../../../../node_modules/@mui/material/index";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  width: "90vw",
  borderRadius: "10px",
  maxHeight: "90vh",
  overflowY: "scroll",
};

const ExperienceSubmissionReport = ({ setDisableDropdown }) => {
  const { dispatch } = useContext(Context);
const [employmentStatus,setEmploymentStatus] =  useState('All')
  const { getExperienceSubmissionReportAPI } = reportAPI();

  const handleExport = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    setDisableDropdown(true);
    await getExperienceSubmissionReportAPI(employmentStatus);
    setDisableDropdown(false);
    dispatch({ type: "SET_LOADING", payload: false });
  };

  const statusLabels = {
    All: "Active & InActive",
    Active: "Active",
    Inactive: "InActive",
  };

  return (
    <div>
      <Grid container spacing={4} sx={{ mt: 2 }}>
           <Grid item xs={6} sm={6} md={3} lg={4}>
          <Box className="labelproj">Status
            <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="vra-label-2"
              id="vra-select-2"
              name="vra-select-2"
              // multiple
              displayEmpty
              value={employmentStatus}
              onChange={(e) => {
                setEmploymentStatus(e.target.value);
              }}
              inputProps={{ "aria-label": "Timesheet Status" }}
                renderValue={(selected) => {
        if (!selected) {
          return <em>Select Status</em>;
        }
       return statusLabels[selected];
      }}
            >
              <MenuItem value={"All"}>Active & InActive</MenuItem>
              <MenuItem value={'Active'}>Active</MenuItem>
              <MenuItem value={'Inactive'}>InActive</MenuItem>
            
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>
          <Button
            className="download-btn"
            startIcon={
              <DownloadForOfflineIcon
                style={{ fontSize: 30, verticalAlign: "middle" }}
              />
            }
            onClick={handleExport}
          >
            Export
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default ExperienceSubmissionReport;
